module.exports = __webpack_public_path__ + "img/Element4_Fehler_Ziffernrechnen.52cfe602.png";